import React from 'react';
import GraduationHat from 'src/app/icons/Monospaced/GraduationHat/GraduationHat';
import CurrencyDollar from 'src/app/icons/Monospaced/Currency/CurrencyDollar';
import Settings01 from 'src/app/icons/Monospaced/Settings/Settings01';
import MessageHeartCircle from 'app/icons/Monospaced/MessageHeartCircle/MessageHeartCircle';
import Stars02 from 'src/app/icons/Monospaced/Stars/Stars02';
import Announcement01 from 'src/app/icons/Monospaced/Announcement/Announcement01';
import { cssVar } from 'src/app/styles/helper';
import { FeaturesStack } from './ProductsMegaMenu.styles';
import Typography from 'src/app/atoms/Typography/Typography';
import Grid from 'src/app/atoms/Layout/Grid/Grid';
import MegaMenuLink from 'src/app/molecules/Header/MegaMenu/MegaMenuLink';
import Stack from 'atoms/Layout/Stack/Stack';
import UserCircle from 'app/icons/Monospaced/User/UserCircle';

const featureLinks = [
  {
    label: 'Community',
    href: '/community',
    icon: (
      <MessageHeartCircle
        width={20}
        color={cssVar('fg-brand-primary')}
      />
    ),
  },
  {
    label: 'Payments',
    href: '/payments',
    icon: (
      <CurrencyDollar
        width={20}
        color={cssVar('fg-brand-primary')}
      />
    ),
  },
  {
    label: 'Courses',
    href: '/online-courses',
    icon: (
      <GraduationHat
        width={20}
        color={cssVar('fg-brand-primary')}
      />
    ),
  },
  {
    label: 'Admin',
    href: '/admin',
    icon: (
      <Settings01
        width={20}
        color={cssVar('fg-brand-primary')}
      />
    ),
  },
  {
    label: 'Members',
    href: '/members',
    icon: (
      <UserCircle
        width={20}
        color={cssVar('fg-brand-primary')}
      />
    ),
  },
  {
    label: 'AI Cohost',
    href: '/ai',
    icon: (
      <Stars02
        width={20}
        color={cssVar('fg-brand-primary')}
      />
    ),
  },
  {
    label: 'Marketing',
    href: '/marketing',
    icon: (
      <Announcement01
        width={20}
        color={cssVar('fg-brand-primary')}
      />
    ),
  },
];

const ProductsMegaMenuFeatures = (): JSX.Element => {
  return (
    <FeaturesStack
      direction='column'
      align='stretch'
      justify='flex-start'
      gap={'spacing-lg'}
      padding={['spacing-3xl', 'spacing-3xl', 'spacing-3xl', 'spacing-none']}
      paddingLg='spacing-xl'
    >
      <Typography
        type='paragraph'
        size='sm'
        fontWeight='font-weight-semibold'
        color='text-brand-secondary'
      >
        Product
      </Typography>
      <Grid
        totalColumns={2}
        totalColumnsLg={1}
      >
        <Stack direction='column'>
          {featureLinks
            .filter((_, i) => i % 2 === 0)
            .map((link) => (
              <MegaMenuLink
                key={link.label}
                {...link}
              />
            ))}
        </Stack>
        <Stack direction='column'>
          {featureLinks
            .filter((_, i) => i % 2 === 1)
            .map((link) => (
              <MegaMenuLink
                key={link.label}
                {...link}
              />
            ))}
        </Stack>
      </Grid>
    </FeaturesStack>
  );
};

export default ProductsMegaMenuFeatures;
